module.exports = __webpack_public_path__ + "static/babah-697e02e10912a5f6178729b76e89fa3f.png";